'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = exports.Cookies = function () {

	/**
  * Constructor for the JG cookie utility class
  * @param {string} analyticsCookieName
  * @paran {object} cookieSource - for unit testing
  */
	function Cookies(analyticsCookieName) {
		var cookiesSource = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

		_classCallCheck(this, Cookies);

		this._analyticsCookieName = analyticsCookieName || '';
		this._cookiesSource = cookiesSource;
		this._cookies = null;
	}

	/**
  * for a given JG cookie convert it's content
  * into an object (with the appropriate keys/values)
  * @returns {object}
  */


	_createClass(Cookies, [{
		key: 'cookieToObject',
		value: function cookieToObject(cookieName) {
			var _cookies = this.cookies;
			var _cookie = null;
			var _cookieValues = {};
			_cookie = _cookies[cookieName];
			if (_cookie) {
				_cookie.split('&').forEach(function (part) {
					var _keyVal = part.split('=');
					_cookieValues[_keyVal[0]] = _keyVal[1];
				});
			}
			return _cookieValues;
		}

		/**
   * 'Getter' for the cookies source.
   * @description This is primarily here for testing
   * purposes. Think what yo get from 'document.cookie'
   * @returns {string}
   */

	}, {
		key: 'cookiesSource',
		get: function get() {
			if (this._cookiesSource === null) {
				this._cookiesSource = document.cookie;
			}
			return this._cookiesSource;
		}

		/**
   * 'Getter' for our cookies
   * @returns {object} key/value pairs
   */

	}, {
		key: 'cookies',
		get: function get() {
			if (this._cookies === null) {
				this._cookies = {};
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = this.cookiesSource.split('; ')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var _cookie = _step.value;

						var _equalsIndex = _cookie.indexOf('=');
						var _key = _cookie.substr(0, _equalsIndex);
						var _value = _cookie.substr(_equalsIndex + 1, _cookie.length);
						this._cookies[_key] = decodeURIComponent(_value);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
			return this._cookies;
		}

		/**
   * 'Getter' for the values/content of the JG
   * Analytics cookie.
   * @returns {object} - content split into keys/values
   */

	}, {
		key: 'analyticsCookie',
		get: function get() {
			return this.cookieToObject(this._analyticsCookieName);
		}

		/**
   * 'Getter for the values/content of
   * the JG AB Logged in cookie
   * @returns {string} - the id this cookie contains
   */

	}, {
		key: 'JgAbLoggedInCookie',
		get: function get() {
			return this.cookies.JGABID ? { value: this.cookies.JGABID.replace('id=', '') } : '';
		}

		/**
   * 'Getter' for the values/content of
   * the JG User Metadata cookie
   * @returns {object}
   */

	}, {
		key: 'JgUserMetadataCookie',
		get: function get() {
			return this.cookieToObject('JGUserMetadata');
		}
	}]);

	return Cookies;
}();


// WEBPACK FOOTER //
// ../~/dna-core/lib/utils/js/cookies.js